import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  active: "_uqxaa70bpv",
  flipped: "_uqxfldq8hv"
});
const list = "_uqxl1od9k63";
const button = "_uqxb1mdixgo";

export { button, list, modifiers };
import "./steps.style.linaria.module.css";
//# sourceMappingURL=steps.style.js.map
